// extracted by mini-css-extract-plugin
export default {"root":"Title-modules__root__or9ql"};